const STYLES = {
  Hot: "bg-red-100 text-red-700 border-red-200",
  Warm: "bg-orange-100 text-orange-700 border-orange-200",
  Cold: "bg-slate-100 text-slate-600 border-slate-200",
};
const DOTS = { Hot: "bg-red-500", Warm: "bg-orange-500", Cold: "bg-slate-400" };

export const LeadBadge = ({ label }) => (
  <span data-testid="lead-status-badge"
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${STYLES[label] || STYLES.Cold}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${DOTS[label] || DOTS.Cold}`} />
    {label}
  </span>
);
